<div class="profile__content">
  <h1 class="profile__name">{{ profile.fullName }}</h1>
  <p class="profile__overview" [innerHTML]="profile.overview"></p>
  <img
    *ngIf="profileImage"
    class="profile__img"
    alt="profile image"
    src="{{ profileImage }}"
  />
</div>
